import React from 'react';
import { Modal } from '@mantine/core';
import './ComparisonModal.css';

interface ComparisonScopeModalProps {
  isOpen: boolean;
  categoryName: string;
  onChooseCategory: () => void;
  onChooseAll: () => void;
  onCancel: () => void;
}

export const ComparisonScopeModal: React.FC<ComparisonScopeModalProps> = ({
  isOpen,
  categoryName,
  onChooseCategory,
  onChooseAll,
  onCancel,
}) => {
  return (
    <Modal
      opened={isOpen}
      onClose={onCancel}
      title=""
      size="md"
      centered
      withCloseButton={true}
      classNames={{
        content: 'comparison-modal-content',
        header: 'comparison-modal-header',
        body: 'comparison-modal-body',
      }}
    >
      <div className="comparison-modal">
        <h2 className="comparison-question" style={{ marginBottom: 4 }}>Compare against...</h2>
        <p style={{ color: '#888', marginTop: 0, marginBottom: 20, textAlign: 'center', fontSize: '0.95rem' }}>
          How should we rank this task?
        </p>

        <div className="comparison-cards">
          <div className="comparison-card-wrapper">
            <button
              className="comparison-card"
              onClick={onChooseCategory}
              type="button"
            >
              <div className="comparison-card-title">Within "{categoryName}"</div>
              <div className="comparison-card-category">Compare only against other tasks in this category</div>
            </button>
          </div>

          <div className="comparison-vs-badge">or</div>

          <div className="comparison-card-wrapper">
            <button
              className="comparison-card"
              onClick={onChooseAll}
              type="button"
            >
              <div className="comparison-card-title">All tasks</div>
              <div className="comparison-card-category">Compare against tasks from every category</div>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
